export default __webpack_public_path__ + "static/media/greeting4.780c186c.png";